export interface AnalyticsTooltipRow {
  label: string;
  value: string;
  color: string;
}

export interface AnalyticsTooltipResult {
  title: string;
  data: { label: string; value: string }[];
  symbol?: {
    marker: {
      enabled: boolean;
      shape: "circle";
      fill: string;
    };
  };
}

export const createAnalyticsTooltipResult = ({
  title,
  rows,
  symbolColor,
}: {
  title: string;
  rows: AnalyticsTooltipRow[];
  symbolColor?: string;
}): AnalyticsTooltipResult => {
  const result: AnalyticsTooltipResult = {
    title,
    data: rows.map(({ label, value }) => ({ label, value })),
  };

  if (symbolColor) {
    result.symbol = {
      marker: {
        enabled: true,
        shape: "circle",
        fill: symbolColor,
      },
    };
  }

  return result;
};

const escapeHtml = (value: string): string =>
  value
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;");

export { escapeHtml };

export const createAnalyticsTooltipHtml = ({
  title,
  showTitle = true,
  rows,
}: {
  title: string;
  showTitle?: boolean;
  rows: AnalyticsTooltipRow[];
}) =>
  `<div style="display: flex; flex-direction: column; gap: 4px;">
    ${
      showTitle
        ? `<div style="padding: 4px 8px; font-weight: 500; color: #374151;">
            ${escapeHtml(title)}
          </div>`
        : ""
    }
    <div style="padding: 0px 8px;">
      ${rows
        .map(
          row => `
            <div style="display: flex; justify-content: space-between; gap: 12px; margin-bottom: 4px;">
              <div style="display: flex; align-items: center; gap: 4px;">
                <div style="width: 10px; height: 10px; border-radius: 50%; background-color: ${escapeHtml(
                  row.color,
                )};"></div>
                <span style="font-weight: 500; color: #6B7280;">${escapeHtml(row.label)}:</span>
              </div>
              <div style="margin-left: 12px; font-weight: 500; color: #374151; text-align: right; white-space: nowrap;">
                ${escapeHtml(row.value)}
              </div>
            </div>
          `,
        )
        .join("")}
    </div>
  </div>`.trimStart();
